/**
 * @fileoverview GET handler for the "/app_settings/get_territories_with_filters" endpoint
 */
/* eslint-disable camelcase */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appSettingsGetTerritoriesWithFilters } from "./constants";
import type { GetTerritoriesWithFiltersResult } from "./types";

export const getAppSettingsGetTerritoriesWithFilters = reactQueryFetcherAdapter(
  appSettingsGetTerritoriesWithFilters,
  (signal: AbortSignal, territory_ids: string[]): Promise<GetTerritoriesWithFiltersResult> => {
    return fetch("/app_settings/get_territories_with_filters", "GET", { territory_ids }, { signal });
  }
);
